import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import SideNav from "../components/SideNav";
import SideNavShort from "../components/SideNavShort";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { apiKey } from "../config/config";

function DashboardLayout({ language, dir, currentLangFunc, currentDir }) {
  const session = sessionStorage.getItem("aman-admin");
  let token = null;
  let branchId = null;
  let isLightMode = false;
  let useShift = 1;

  try {
    if (session) {
      const parsedSession = JSON.parse(session);
      const adminObj = JSON.parse(parsedSession?.admin || "{}");
      token = adminObj?.token || null;
      branchId = adminObj?.branch_id || null;
      isLightMode = adminObj?.light_mode === "yes";
      useShift = adminObj?.use_shift;
    }
  } catch (e) {
    token = null;
    branchId = null;
    isLightMode = false;
  }
  const location = useLocation();
  const [isShiftOpen, setIsShiftOpen] = useState(true);

  useEffect(() => {
    if (!branchId || !token) {
      setIsShiftOpen(false);
      return;
    }
    if (useShift) {
      axios
        .get(`${apiKey}/shift-data/` + branchId, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res.data.Message === "No Active Shift") {
            setIsShiftOpen(false);
          } else {
            setIsShiftOpen(true);
          }
        })
        .catch((err) => {
          console.error(err);
          setIsShiftOpen(false);
        });
    }
  }, [branchId, token]);

  if (isShiftOpen === null) {
    return (
      <div
        className="d-flex justify-content-center align-items-center w-100"
        style={{ height: "100vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isShiftOpen && location.pathname !== "/dashboard/open-shift") {
    return <Navigate to="/dashboard/open-shift" replace />;
  }

  if (isShiftOpen && location.pathname === "/dashboard/open-shift") {
    return <Navigate to="/dashboard" replace />;
  }

  const NavigationBar = isLightMode ? SideNavShort : SideNav;

  return (
    <div className="mx-auto" dir={`${dir}`}>
      <ToastContainer />
      <NavigationBar
        lang={language}
        dirFormat={dir}
        currentLangFunc={currentLangFunc}
        currentDir={currentDir}
      />
      <main className={`main ${dir === "rtl" ? "main-right" : "main-left"}`}>
        <Outlet context={{ onShiftOpened: () => setIsShiftOpen(true) }} />
      </main>
    </div>
  );
}

export default DashboardLayout;
